// Live FX rate via exchangerate-api.com. Returns the rate to multiply a
// `from`-currency amount by to get `to`-currency. Same currency → 1.
// NOTE: the key ships to the browser; move to a VITE_ env var if it should be hidden.
const EXCHANGE_RATE_API_KEY = "5748090ee5816db9ade1ac94";

export async function getExchangeRate(
  from: string,
  to: string,
): Promise<number> {
  if (!from || !to || from.toUpperCase() === to.toUpperCase()) return 1;
  const res = await fetch(
    `https://v6.exchangerate-api.com/v6/${EXCHANGE_RATE_API_KEY}/latest/${encodeURIComponent(
      from.toUpperCase(),
    )}`,
  );
  if (!res.ok) throw new Error("Failed to fetch exchange rate");
  const data = await res.json();
  if (data?.result !== "success") {
    throw new Error("Exchange rate request unsuccessful");
  }
  const rate = data?.conversion_rates?.[to.toUpperCase()];
  if (typeof rate !== "number") throw new Error("Rate not available");
  return rate;
}
